import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { terminalsService } from '../../../services/terminalsService';
import { LookupDto } from '../../../models/common/lookup.dto';
import { TerminalFilter } from '../../../models/terminals/terminalFilter';

interface TerminalsAutocompleteFormControlProps {
    name: string;
    companyId?: number | null;
    label?: string;
    style?: React.CSSProperties;
    required?: boolean;
}

const TerminalsAutocompleteFormControl: React.FC<TerminalsAutocompleteFormControlProps> = ({ name, companyId, label = 'Терминалы', style, required }) => {
    const { control, setValue } = useFormContext();
    const [options, setOptions] = useState<LookupDto[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setValue(name, []);
        
        setLoading(true)
        const filter: TerminalFilter = {
            companyId: companyId ?? undefined,
            page: 0,
            pageSize: 1000
        };
        terminalsService.getByFilter(filter)
            .then(results => setOptions(results.data.data.items))
            .catch(() => setOptions([]))
            .finally(() => setLoading(false));
    }, [companyId, name, setValue]);

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: required ? 'Обязательное поле' : false }}
            render={({ field, fieldState }) => (
                <Autocomplete
                    multiple
                    options={options}
                    getOptionLabel={option => option.name}
                    value={field.value}
                    onChange={(_, value) => {
                        field.onChange(value);
                    }}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            margin="dense"
                            size="small"
                            style={style}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            required={required}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                    size="small"
                    disabled={!companyId}
                />
            )}
        />
    );
};

export default TerminalsAutocompleteFormControl;
